/* eslint-disable react/prop-types */
import React, { useEffect, useRef } from "react";
import { useInfiniteQuery } from "react-query";

import { getAcastEpisodes } from "../helper/api";
import { EpisodeItem } from "./episode-item";
import { BackIcon, CloseIcon } from "./icons";
import { Loader } from "./Loader";


import "./show-list.m.css";

const shows = require("./shows.json");

export function ShowList({ handleClick, handleClose, currentShow }) {

  useEffect(()=>{
    console.log(shows);
    if(currentShow==="charcha"){
      handleClick(shows[4]);
    }
    else if(currentShow==="potli")
      handleClick(shows[5]);
  },[])

  return (
    <div styleName="show_list">
      <div styleName="show_list_content">
        <div styleName="top_sticky" style={{ display: "flex", justifyContent: "flex-end" }}>
          <button title="Close" aria-label="Close" onClick={handleClose} className="pressable">
            <CloseIcon width={18} />
          </button>
        </div>
        <header>
          <div styleName="heading heading__list">Shows</div>
        </header>
        {shows.map(show => {
          return (
            <article key={show._id}>
              <button onClick={() => handleClick(show)} className="pressable">
                <section>
                  <div styleName="show_list_meta">
                    <img src={show.cover} styleName="show_list_artwork_cover" alt={show.title}></img>
                    <div styleName="show_list_meta_text show_list_meta_text--podcast">
                      <div styleName="heading">{show.title}</div>
                      <div styleName="show_list_meta_title">{show.summary}</div>
                    </div>
                  </div>
                </section>
              </button>
            </article>
          );
        })}
      </div>
    </div>
  );
}

async function getEpisodes(_key, params, cursor) {
  return getAcastEpisodes(params.podcastId, cursor || 1);
}

export function EpisodeList({ podcast, handleBack, handleClose }) {
  const listRef = useRef(null);

  const { status, data, error, isFetchingMore, fetchMore, canFetchMore } = useInfiniteQuery(
    ["podcastEpisodes", { podcastId: podcast._id }],
    getEpisodes,
    {
      getFetchMore: lastGroup => {
        return lastGroup.nextPage;
      }
    }
  );

  function renderList() {
    return status === "loading" ? (
      <div style={{ width: "100%", marginTop: "2rem" }}>
        <Loader />
      </div>
    ) : status === "error" ? (
      <p>Error: {error.message}</p>
    ) : (
      data.map((group, i) => (
        <React.Fragment key={i}>
          {group.body.episodes.map(episode => (
            <EpisodeItem key={episode._id} episode={episode} podcast={podcast} />
          ))}
        </React.Fragment>
      ))
    );
  }

  const loadMore = () => {
    if (canFetchMore && !isFetchingMore) {
      fetchMore();
    }

    if (canFetchMore === undefined && !isFetchingMore) {
      fetchMore();
    }
  };

  return (
    <div ref={listRef} styleName="show_list">
      <div styleName="show_list_content">
        <div style={{ display: "flex", justifyContent: "space-between" }} styleName="top_sticky">
          <button title="Go back to shows" aria-label="Go back to show list" onClick={handleBack} className="pressable">
            <BackIcon width={32} />
          </button>
          <button title="Close" aria-label="Close" onClick={handleClose} className="pressable">
            <CloseIcon width={18} />
          </button>
        </div>
        <header styleName="header">
          <div style={{ marginRight: "1rem" }}>
            <div style={{ fontSize: "1.5rem" }} styleName="heading heading__list">
              {podcast.title}
            </div>
            <div styleName="header_summary">{podcast.summary}</div>
          </div>
          <img src={podcast.cover} styleName="header__artwork" alt="podcast cover"></img>
        </header>
        <ScrollView listRef={listRef} onEndReached={loadMore}>
          {renderList()}
        </ScrollView>
        <div style={{ textAlign: "center" }}>{isFetchingMore ? "Loading more episodes..." : null}</div>
      </div>
    </div>
  );
}

const ScrollView = ({ onEndReached, children, listRef }) => {
  const called = useRef(false);

  useEffect(() => {
    if (listRef) {
      const elem = listRef.current;
      elem.addEventListener("scroll", () => {
        if (elem.offsetHeight + elem.scrollTop + 400 >= elem.scrollHeight) {
          if (!called.current) {
            onEndReached();
            called.current = true;
          }
          setTimeout(() => {
            called.current = false;
          }, 1000);
        }
      });
    }
  }, [listRef, onEndReached]);
  return children;
};
